import axios from "axios";
import { baseURL } from "../utils/URL";

const onAddAppraisalTemp = async (postData: any, config: any) => {
  try {
    const response = await axios.post(
      `${baseURL}/appraisal/template`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onAddAppQuestion = async (postData: any, config: any) => {
  try {
    const response = await axios.post(
      `${baseURL}/template/question`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onAddAppraisal = async (postData: any, config: any) => {
  try {
    const response = await axios.post(`${baseURL}/appraisal`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onAddAppraisalResponse = async (postData: any, config: any) => {
  try {
    const response = await axios.post(`${baseURL}/template/response`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onUpdateAppraisal = async (ApprID:number,postData: any, config: any) => {
  try {
    const response = await axios.patch(`${baseURL}/appraisal/${ApprID}`, postData, config);
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onUpdateQuestion = async (id: number, postData: any, config: any) => {
  try {
    const response = await axios.patch(
      `${baseURL}/template/question/${id}`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onUpdateAppTempinfo = async (id: number, postData: any, config: any) => {
  try {
    const response = await axios.patch(
      `${baseURL}/appraisal/template/${id}`,
      postData,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};

const onGetOrgAppTemplates = async (id: number, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/appraisal/template/organization/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetOrgTemplateAppr = async (templateID: number, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/goal/template/${templateID}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetOrgAppraisals = async (id: number, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/appraisal/organization/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetAllOrgAppraisals = async (id: number, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/appraisal/organization/all/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const ongetEmployeeAppr = async (id: number, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/appraisal/employee/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
const onGetOrgAppTempQuests = async (id: number, config: any) => {
  try {
    const response = await axios.get(
      `${baseURL}/template/question/template/${id}`,
      config
    );
    return response.data;
  } catch (error: any) {
    console.log(error?.response);
    if (error?.response?.data?.message === undefined) {
      throw error.message;
    } else {
      throw error?.response?.data?.message;
    }
  }
};
export {
  onAddAppraisalTemp,
  ongetEmployeeAppr,
  onGetAllOrgAppraisals,
  onGetOrgAppraisals,
  onGetOrgTemplateAppr,
  onAddAppraisal,
  onUpdateQuestion,
  onAddAppraisalResponse,
  onUpdateAppTempinfo,
  onGetOrgAppTempQuests,
  onUpdateAppraisal,
  onAddAppQuestion,
  onGetOrgAppTemplates,
};
